import React from 'react';
import { DateTime } from 'luxon';
import { usePager } from '../../../helpers/pagination';
import SideBar from '../../Common/SideBar';
import PageIndicator from '../../Common/PageIndicator';
import Row from './Row';
import SpotlightHeader from '../../Common/Header';
import './StoreSpeedOfService.scss';
const getFormattedData = (data, metadata) => {
  var _metadata$results;
  const {
    top,
    own,
    dob
  } = data;
  const results = (_metadata$results = metadata.results) !== null && _metadata$results !== void 0 ? _metadata$results : 10;
  const description = `Speed of Service by store for ${dob ? DateTime.fromISO(dob).toFormat('MM/dd') : 'N/A'}`;
  const stores = top.slice(0, results);
  const isOwnInRanking = (own === null || own === void 0 ? void 0 : own.ranking) <= results;
  const hide_poweredbyshift = metadata.hide_poweredbyshift;
  return {
    own,
    description,
    stores,
    isOwnInRanking,
    hide_poweredbyshift
  };
};
const StoreSpeedOfService = props => {
  const {
    data,
    metadata,
    text,
    duration,
    playing,
    bohStyle
  } = props;
  const {
    accent_color,
    title_font_family,
    text_accent_color,
    containerStyle,
    listHeaderRowStyle
  } = bohStyle;
  const {
    own,
    description,
    stores,
    isOwnInRanking,
    hide_poweredbyshift
  } = getFormattedData(data, metadata);
  const [page, pageIdx, pages] = usePager(stores, duration * 1000, playing);
  return /*#__PURE__*/React.createElement("div", {
    className: "store-speed-of-service",
    style: containerStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "width-container"
  }, /*#__PURE__*/React.createElement(SpotlightHeader, {
    text: text,
    metadata: metadata,
    description: description,
    isLeaderboard: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "sos-table"
  }, /*#__PURE__*/React.createElement("div", {
    className: "list-row list-header",
    style: listHeaderRowStyle
  }, /*#__PURE__*/React.createElement("p", {
    className: "employee_header"
  }, "Location"), /*#__PURE__*/React.createElement("p", null, "Speed of Service")), page.map((store, index) => /*#__PURE__*/React.createElement(Row, {
    key: `${store.location}-${index}`,
    store: store,
    accent_color: accent_color,
    text: text,
    isOwn: store.ranking === (own === null || own === void 0 ? void 0 : own.ranking)
  })), !!own && !isOwnInRanking && /*#__PURE__*/React.createElement(Row, {
    key: `${own.location}-last-row`,
    store: own,
    accent_color: accent_color,
    isOwn: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "results-description"
  }, "Results ordered by SOS time")), pages.length > 1 && /*#__PURE__*/React.createElement(PageIndicator, {
    pages: pages,
    current: pageIdx,
    selectedColor: accent_color
  })), /*#__PURE__*/React.createElement(SideBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    logo: metadata.logo,
    text: text.message_board,
    fontFamily: title_font_family,
    hide_poweredbyshift: hide_poweredbyshift
  }));
};
export default StoreSpeedOfService;